import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import { importerDemoCanaux } from './demo-sdk.js';

/**
 * L'APP CANAUX (`canaux`), UNE APP CANVAS DECLAREE (regle G23).
 *
 * PAS DE PORTE, DONC NI `taki.fields.json` NI `taki.screens.json` : le
 * niveau App Canvas retire le rail, l'app entiere est UNE surface. La
 * derogation est deja accordee et ECRITE dans `taki.app.json` (cle
 * `canvas.app`) ; `definirAppDeclaree` refuse la clef `appCanvas` sans elle,
 * et `pnpm canvas:check` confronte les deux en CI.
 *
 * L'ECRAN VIENT DU SOCLE (`EcranAppCanvas`, `@taki/app-runtime`) : le
 * gabarit reduit, la recherche et les stats reprises par la fiche, le filet
 * d'erreur, le chargement paresseux. `SurfaceDonnees.tsx` branche le SDK ;
 * `Surface.tsx` garde la presentation et sa source de demonstration pour les tests.
 *
 * LE CHARGEUR RESTE UN `import()` : la surface et son moteur ne partent dans
 * le bundle d'un client que s'il ouvre l'app. Le kit de la surface (galerie,
 * sauvegarde, conflits) : `docs/SURFACES-CANVAS.md`.
 */
export const canauxApp = definirAppDeclaree({
  fiche: appInfo,
  appCanvas: { charger: () => import('./SurfaceDonnees.js') },
  demo: {
    local: true,
    ecrit: [{ family: 'conversations', type: 'canal' }, { family: 'messages', type: 'conversation' }],
    importer: ({ sdk, orgId, moi }) => importerDemoCanaux(sdk, { orgId, local: true }, moi ?? ''),
  },
});

export default canauxApp;
